import { render, staticRenderFns } from "./SettingDeleteConfirm.vue?vue&type=template&id=b3294ee0"
import script from "./SettingDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./SettingDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports